import { createContext } from 'react';

export const Width = createContext(0);

export const WidthProvider = Width.Provider;
export const WidthConsumer = Width.Consumer;
